import { render } from "./DeliverColisPage.vue?vue&type=template&id=96c8943e&ts=true"
import script from "./DeliverColisPage.vue?vue&type=script&lang=ts"
export * from "./DeliverColisPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__